<iris-card class="pvl-container">

  <h3 data-dd-privacy="allow">Primary virtual location</h3>
  <div>
    <div class="iris-body-responsive">
      This is the physical address where you have the majority of your video telehealth sessions. It's not visible to
      clients.
    </div>

    <form [formGroup]="pvlForm" (keydown.enter)="enterSubmit($event)">
      <div class="street-line">
        <iris-form-field class="address1" label="Street Address" [customErrorMessages]="pvlErrors">
          <iris-text-input 
            formControlName="address_line1"
            googleMapsAutoComplete
            [autocompleteParams]="{ componentRestrictions: { country: 'us' }, types: ['address'] }"
            (onAutoCompleteSelected)="locationSelected($event)"
            data-test="pvl-address1"
          >
          </iris-text-input>
        </iris-form-field>
        <iris-form-field class="address2" label="Apartment, unit, suite, or floor #" [customErrorMessages]="pvlErrors">
          <iris-text-input formControlName="address_line2">
          </iris-text-input>
        </iris-form-field>
      </div>
      <div class="city-state-zip-line">

        <iris-form-field class="city" label="City" [customErrorMessages]="pvlErrors">
          <iris-text-input formControlName="city">
          </iris-text-input>
        </iris-form-field>
        <iris-form-field class="state" label="State" [customErrorMessages]="pvlErrors">
          <iris-text-input formControlName="state">
          </iris-text-input>
        </iris-form-field>
        <iris-form-field class="zip" label="Zip Code" [customErrorMessages]="pvlErrors">
          <iris-text-input formControlName="postal_code">
          </iris-text-input>
        </iris-form-field>
      </div>
      <div *ngIf="saveFailure && serverValidationFailedCount > 1" class="iris-body-responsive pvl-error">
        We can't verify the address you entered. Make sure it's correct or you can reach out to
        <a href="mailto:providersuccess&#64;sondermind.com">providersuccess&#64;sondermind.com</a>
        for assistance.
      </div>
      <iris-button-container class="button-container" [alignment]="IrisButtonContainerAlignments.END" data-dd-privacy="allow">
        <iris-button
          class="save-button"
          [disabled]="saving || !pvlForm.valid"
          (click)="savePvl()"
          data-test="save-pvl"
        >
          Save
          <mat-spinner *ngIf="saving" diameter="24"></mat-spinner>
        </iris-button>
      </iris-button-container>

    </form>

  </div>
</iris-card>